module.exports = __webpack_public_path__ + "static/media/home_medication.88a29e78.png";